module.exports = __webpack_public_path__ + "static/media/roger_orlando.8dcfe105.jpeg";